import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import type { components } from "../generated/schema";
import type { BoatCode } from "@/types/identifiers";

export type TeamSyncStatus = components["schemas"]["app__schemas__admin__TeamSyncStatus"];

export function useTeamSyncStatuses() {
  return useQuery({
    queryKey: ["admin", "calibration-sync", "teams"],
    queryFn: async () => {
      const result = await api.GET("/api/admin/calibration-sync/teams");
      return throwIfError(result, "Failed to fetch team sync statuses");
    },
  });
}

export async function compareGolden(boatCode: BoatCode) {
  const result = await api.POST(
    "/api/admin/calibration-sync/{boat_code}/compare",
    { params: { path: { boat_code: boatCode } } },
  );
  return throwIfError(result, "Failed to compare calibration");
}

export async function restoreGolden(boatCode: BoatCode) {
  const result = await api.POST(
    "/api/admin/calibration-sync/{boat_code}/restore",
    { params: { path: { boat_code: boatCode } } },
  );
  return throwIfError(result, "Failed to restore calibration");
}

export async function acceptLiveAsGolden(boatCode: BoatCode, eventId: string) {
  const result = await api.POST(
    "/api/admin/calibration-sync/{boat_code}/accept",
    { params: { path: { boat_code: boatCode }, query: { event_id: eventId } } },
  );
  return throwIfError(result, "Failed to accept live calibration");
}
